import axios from 'axios'
import { api, tokenManager } from './instance'
import type { User, LoginRequest, LoginResponse, RefreshTokenResponse, ChangePasswordRequest } from '../types'

export const authApi = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const { data } = await api.post('/auth/login', credentials)
    tokenManager.setTokens(data.accessToken, data.refreshToken)
    return data
  },

  logout: async (): Promise<void> => {
    try {
      await api.post('/auth/logout', { refreshToken: tokenManager.getRefreshToken() })
    } finally {
      tokenManager.clearTokens()
    }
  },

  refresh: async (): Promise<RefreshTokenResponse> => {
    const refreshToken = tokenManager.getRefreshToken()
    if (!refreshToken) {
      throw new Error('No refresh token available')
    }
    const { data } = await axios.post<RefreshTokenResponse>('/api/auth/refresh', { refreshToken })
    tokenManager.setTokens(data.accessToken, data.refreshToken)
    return data
  },

  me: async (): Promise<User> => {
    const { data } = await api.get('/auth/me')
    return data
  },

  changePassword: async (request: ChangePasswordRequest): Promise<void> => {
    await api.post('/auth/change-password', request)
  },

  checkSetupRequired: async (): Promise<{ setupRequired: boolean; adminEmail: string | null }> => {
    const { data } = await api.get('/auth/setup-required')
    return data
  },

  initialSetup: async (request: { password: string; confirmPassword: string; email?: string }): Promise<{ success: boolean; message: string }> => {
    const { data } = await api.post('/auth/setup', request)
    return data
  },
}
